/**
 * 专题 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = "/c-api/";

const zhuanti = {
    // 列表
    list(params) {
        return axios.get(api + "zhuanti/list", { params: params });
    },
    // 添加
    create(params) {
        return axios.post(api + "zhuanti/create", qs.stringify(params));
    },
    //详情
    detail(params) {
        return axios.get(api + "zhuanti/detail", { params: params });
    },
    //修改
    edit(params) {
        return axios.post(api + "zhuanti/edit", qs.stringify(params));
    },
    // 删除
    remove(params) {
        return axios.post(api + "zhuanti/remove", qs.stringify(params));
    },
	// 更新专题状态
	updstatus(params){
		return axios.post(api + "zhuanti/updstatus", qs.stringify(params));
	},
	// 分类列表
	catelist(params){
		return axios.get(api + "zhuantiblockcate/list", { params: params });
	},
	// 模块列表
	blocklist(params){
		return axios.get(api + "zhuantiblock/list", { params: params });
	},
	// 查分类的内容
	catecontent(params){
		return axios.get(api + "zhuantiblockcate/contentlist", { params: params });
	},
	// 添加模块
	blockcreate(params){
		return axios.post(api + "zhuantiblock/create", qs.stringify(params));
	},
	// 模块详情
	blockdetail(params){
		return axios.get(api + "zhuantiblock/detail", { params: params });
	},
	// 修改模块
	blockedit(params){
		return axios.post(api + "zhuantiblock/edit", qs.stringify(params));
	},
	// 删除
	blockremove(params){
		return axios.post(api + "zhuantiblock/remove", qs.stringify(params));
	},
	// 添加分类下内容
	blockcatecontent(params){
		return axios.post(api + "zhuantiblockcate/createcontent", qs.stringify(params));
	},
	// 添加分类
	blockcatecreate(params){
		return axios.post(api + "zhuantiblockcate/create", qs.stringify(params));
	},
	// 模块排序
	blocksort(params){
		return axios.post(api + "zhuantiblock/sort", qs.stringify(params));
	}

};

// 导出接口
export default zhuanti;
